// E.L hard coded for now but will come from db

export default Object.freeze({

  development: {
    ALL: 4,
    LOCAL_THEPORTALIST: 3,
    LOCAL_THE_LINE_UP: 2,
    LOCAL_EARLYBIRDBOOKS: 1,
    LOCAL_PEGASUS_OPENROADMEDIA: 5,
    LOCAL_OPENROADMEDIA: 6,
    LOCAL_MURDER_MAYHEM: 7,
    LOCAL_ALOVESOTRUE: 8,
    LOCAL_EXPLORETHEARCHIVE: 9,
    LOCAL_DASHBOARD_OPENROADMEDIA: 10,
    LOCAL_PEGGY_OPENROADMEDIA: 11
  },

  staging: {
    ALL: 4,
    STAGING_THEPORTALIST: 3,
    STAGING_THE_LINE_UP: 2,
    STAGING_EARLYBIRDBOOKS: 1,
    STAGING_NEWSLETTER_OPENROADMEDIA: 5,
    STAGING_OPENROADMEDIA: 6,
    STAGING_MURDER_MAYHEM: 7,
    STAGING_ALOVESOTRUE: 8,
    STAGING_EXPLORETHEARCHIVE: 9,
    STAGING_DASHBOARD_OPENROADMEDIA: 10,
    STAGING_PEGGY_OPENROADMEDIA: 11
  },

  production: {
    ALL: 4,
    THEPORTALIST: 3,
    THE_LINE_UP: 2,
    EARLYBIRDBOOKS: 1,
    NEWSLETTER_OPENROADMEDIA: 5,
    OPENROADMEDIA: 6,
    MURDER_MAYHEM: 7,
    ALOVESOTRUE: 8,
    EXPLORETHEARCHIVE: 9,
    DASHBOARD_OPENROADMEDIA: 10,
    PEGGY_OPENROADMEDIA: 11
  },

  ALL: 4,
  THEPORTALIST: 3,
  THE_LINE_UP: 2,
  EARLYBIRDBOOKS: 1,
  NEWSLETTER_OPENROADMEDIA: 5,
  OPENROADMEDIA: 6,
  MURDER_MAYHEM: 7,
  ALOVESOTRUE: 8,
  EXPLORETHEARCHIVE: 9,
  DASHBOARD_OPENROADMEDIA: 10,
  PEGGY_OPENROADMEDIA: 11,
  NOT_SITE: -1,

  // E.L
  // sites that have a newsletter
  // NEWSLETTER_KEY - is a key we use to map against the /configuration/constants/Platform.js constants in integration_api.
  // NAME - user friendly name
  NEWSLETTERS: [
    {
      NEWSLETTER_KEY: 'theportalist',
      NAME: 'The Portalist'
    },
    {
      NEWSLETTER_KEY: 'earlybirdbooks',
      NAME: 'Early Bird Books'
    },
    {
      NEWSLETTER_KEY: 'the-line-up',
      NAME: 'The Line Up'
    },
    {
      NEWSLETTER_KEY: 'murder-mayhem',
      NAME: 'Murder & Mayhem'
    },
    {
      NEWSLETTER_KEY: 'alovesotrue',
      NAME: 'A Love So True'
    },
    {
      NEWSLETTER_KEY: 'explorethearchive',
      NAME: 'Explore The Archive'
    },
    {
      NEWSLETTER_KEY: 'youngreaders',
      NAME: 'Open Road Young Readers'
    },
    {
      NEWSLETTER_KEY: 'openroadmedia',
      NAME: 'Early Bird Books'
    },
    {
      NEWSLETTER_KEY: 'ebbreader',
      NAME: 'The Reader'
    }
  ],

  /**
   * [SITETYPES description]
   * STRING REPRESENTATION OT THE SITE TYPE FROM A INT
   */
  SITETYPES: {
    CONTENT_TYPE: 0,
    INTERNAL_TYPE: 1
  },

  HEADERBGCOLORS: [
    {
      HEADERBGCOLOR_KEY: 1,
      COLOR: "#2C68B0"
    },
    {
      HEADERBGCOLOR_KEY: 2,
      COLOR: "#000"
    },
    {
      HEADERBGCOLOR_KEY: 3,
      COLOR: "#3C7D9A"
    },
    {
      HEADERBGCOLOR_KEY: 6,
      COLOR: "#EF4135"
    },
    {
      HEADERBGCOLOR_KEY: 7,
      COLOR: "#F2DE22"
    },
    {
      HEADERBGCOLOR_KEY: 8,
      COLOR: "#E35866"
    },
    {
      HEADERBGCOLOR_KEY: 9,
      COLOR: "#C7B299"
    },
  ],

  HEADERTEXTCOLORS: [
    {
      HEADERTEXTCOLOR_KEY: 1,
      COLOR: "#FFF"
    },
    {
      HEADERTEXTCOLOR_KEY: 2,
      COLOR: "#FFF"
    },
    {
      HEADERTEXTCOLOR_KEY: 3,
      COLOR: "#FFF"
    },
    {
      HEADERTEXTCOLOR_KEY: 6,
      COLOR: "#FFF"
    },
    {
      HEADERTEXTCOLOR_KEY: 7,
      COLOR: "#000"
    },
    {
      HEADERTEXTCOLOR_KEY: 8,
      COLOR: "#FFF"
    },
    {
      HEADERTEXTCOLOR_KEY: 9,
      COLOR: "#000"
    },
  ],

});

export const _SITEID_REVERSE_MAP_ = new Map([
  [-1, 'ebbreader'],
  [1, 'earlybirdbooks'],
  [2, 'the-line-up'],
  [3, 'theportalist'],
  [6, 'openroadmedia'],
  [7, 'murder-mayhem'],
  [8, 'alovesotrue'],
  [9, 'explorethearchive']
]);
